import React, { useState } from 'react';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';

function ViewProductView({ item }) {

    return (<div className="w-full flex-1">
        <StyledHeadingText text="Products" />
        {item.products && item.products.length !== 0 ? (
            <div className="flex flex-col overflow-y-auto gap-2 mt-2 max-h-full">
                {item?.products?.map((itm, index) => (
                    <div key={index} className='p-4 rounded-lg border'>
                        <div className='flex flex-col gap-2'>
                            {/* Product Name */}
                            <h3 className='font-medium text-gray-800'>{itm}</h3>
                        </div>
                    </div>
                ))}
            </div>
        ) : null}
    </div >);
}

export default ViewProductView;